import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import persianJs from "persianjs"

import { PureComponent, GroupBox } from 'core/components';
import { withLocale, withAuth } from 'core/decorators';
import { Icon, List, ListInput, Button, CardContent } from 'core/components/Framework7';
import { registerFinalize, Login } from 'core/module/operations';

import classes from './styles.module.css';

class CompleteProfile extends PureComponent {
  constructor(props) {
    super(props)

    const { user } = this.props;
    this.router = this.$f7.views.current && this.$f7.views.current.router

    this.state = {
      firstName: user && user.firstName || '',
      lastName: user && user.lastName || '',
      email: '',
      password: '',
      passwordRepeat: '',
      referralCode: '',
    }
  }

  get initialValue() {
    const { env } = this.props;

    return {
      page: env && env.pages && env.pages.completeProfile,
    }
  }

  changeEmail(e) {
    this.setState({
      email: e.target.value
    })
  }

  changePassword(e) {
    this.setState({
      password: e.target.value
    })
  }

  changePasswordRepeat(e) {
    this.setState({
      passwordRepeat: e.target.value
    })
  }

  changeReferralCode(e) {
    if (!e.target.value || e.target.value == "") {
      this.setState({
        referralCode: ''
      })

      return
    }

    this.setState({
      referralCode: persianJs(e.target.value).toEnglishNumber().toString()
    })
  }

  changeFirstName(e) {
    this.setState({
      firstName: e.target.value
    })
  }

  changeLastName(e) {
    this.setState({
      lastName: e.target.value
    })
  }

  handleNext() {
    const { user } = this.props;
    const { email, password, referralCode, firstName, lastName } = this.state;

    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    const model = {
      id: user ? user.id : null,
      email,
      password,
      referralCode: referralCode,
      username: user ? user.mobile : null
    }

    const newModel = {
      email,
      password,
      referralCode: referralCode,
      username: user ? user.mobile : null,
      firstName: firstName,
      lastName: lastName,
      mobile: user ? user.mobile : null,
    }

    const params = {
      errorHandler: true
    }

    const finalModel = user && user.id ? model : newModel;

    this.props.registerFinalize(finalModel, params)
      .then(r => {
        this.props.Login(user.mobile, password)
          .then(r => {
            // console.log(this.router)
            // this.router && this.router.back('/profile#/', { force: true })
            this.$f7.dialog.alert('ثبت نام شما با موفقیت انجام شد.', 'ثبت نام موفق', () => window.location.reload())
          })
      })
      .catch(e => {
        // console.log(e)
        this.$f7.dialog.alert('خطایی در ثبت اطلاعات رخ داده است. لطفا اطلاعات ورودی خود را بازنگری کنید.', 'خطا');
      })
      .finally(r => {
        this.$f7.dialog.close()
      })
  }

  hasError() {
    const { firstName, lastName, password, passwordRepeat } = this.state;
    const { user } = this.props

    let valid = false

    if (
      (user || firstName.length >= 2) &&
      (user || lastName.length >= 2) &&
      (password.length >= 4) &&
      (passwordRepeat == password)
    ) {
      valid = true
    }

    return !valid
  }

  renderUsername() {
    const { user } = this.props;

    return (
      <div className={classes.username}>{`${user.firstName} ${user.lastName}`}</div>
    )
  }

  onSubmit(e) {
    e.preventDefault();
  }

  render() {
    const { user } = this.props;
    // const user = {id: 1, firstName: 'علی', lastName: 'فخیمی'}
    const { firstName, lastName, password, passwordRepeat, email, referralCode } = this.state;

    const env = this.initialValue;

    return (
      <form action="" onSubmit={this.onSubmit} className={classes.container}>
        <div className={`${classes.pagePadding}`}>
          <GroupBox outline title={'اطلاعات کاربری'}>
            <CardContent>
              <List noHairlinesMd>
                <ListInput
                  type="text"
                  // label={'نام'}
                  clearButton={!(user && user.id)}
                  required
                  validate
                  value={firstName}
                  placeholder="نام خود را وارد کنید"
                  info={'اجباری'}
                  errorMessage={'لطفا نام خود را وارد کنید'}
                  readonly={!!(user && user.id)}
                  onInputClear={() => this.setState({ firstName: '' })}
                  onChange={this.changeFirstName}
                >
                  <Icon icon="mdi-account" slot="media" />
                </ListInput>

                <ListInput
                  type="text"
                  // label={'نام خانوادگی'}
                  clearButton={!(user && user.id)}
                  required
                  validate
                  value={lastName}
                  placeholder="نام خانوادگی خود را وارد کنید"
                  info={'اجباری'}
                  errorMessage={'لطفا نام خانوادگی خود را وارد کنید'}
                  readonly={!!(user && user.id)}
                  onInputClear={() => this.setState({ lastName: '' })}
                  onChange={this.changeLastName}
                >
                  <Icon icon="mdi-account" slot="media" />
                </ListInput>

                <ListInput
                  type="password"
                  // label={'رمز عبور'}
                  clearButton
                  required
                  validate
                  value={password}
                  placeholder="رمز عبور را وارد کنید"
                  info={'اجباری، حداقل ۴ حرف'}
                  errorMessage={'لطفا رمز عبور خود را وارد کنید'}
                  onInputClear={() => this.setState({ password: '' })}
                  onChange={this.changePassword}
                >
                  <Icon icon="mdi-account-key" slot="media" />
                </ListInput>

                <ListInput
                  type="password"
                  // label={'تکرار رمز عبور'}
                  clearButton
                  required
                  validate={password == passwordRepeat}
                  value={passwordRepeat}
                  placeholder="رمز عبور را مجدد وارد کنید"
                  info={'اجباری، رمز عبور خود را مجدد وارد کنید.'}
                  errorMessage={'لطفا رمز عبور خود را مجدد وارد کنید'}
                  onInputClear={() => this.setState({ passwordRepeat: '' })}
                  onChange={this.changePasswordRepeat}
                >
                  <Icon icon="mdi-account-key" slot="media" />
                </ListInput>

                <ListInput
                  type="email"
                  // label={'ایمیل'}
                  clearButton
                  value={email}
                  placeholder="ایمیل خود را وارد کنید"
                  onInputClear={() => this.setState({ email: '' })}
                  onChange={this.changeEmail}
                >
                  <Icon icon="mdi-email" slot="media" />
                </ListInput>

                <ListInput
                  type="text"
                  // label={'کد معرف'}
                  pattern="\d*"
                  clearButton
                  value={referralCode}
                  placeholder="کد معرف خود را وارد کنید"
                  info={'برای اطلاعات بیشتر، بخش توضیحات مطالعه شود'}
                  onChange={this.changeReferralCode}
                  onInputClear={() => this.setState({ referralCode: '' })}
                  className={classes.input}
                >
                  <Icon icon="mdi-account-arrow-left" slot="media" />
                </ListInput>
              </List>
            </CardContent>
          </GroupBox>

          <GroupBox outline title={'توضیحات'}>
            <CardContent>
              {
                env.page.description.map((text, index) => {
                  return <div key={index}>{`- ${text}`}</div>
                })
              }
            </CardContent>
          </GroupBox>
        </div>

        <Button large fill
          type="submit"
          icon="mdi-account-check"
          text={'تکمیل حساب کاربری'}
          className={`${classes.fullWidthButton}`}
          disabled={this.hasError()}
          onClick={this.handleNext}
        />
      </form>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
    user: state.General.user,
  }),
  {
    registerFinalize,
    Login,
  }
)(withLocale('completeProfile')(withAuth(autobind(CompleteProfile))))